'use strict';

require('@firebase/auth');

//# sourceMappingURL=index.cjs.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/auth/dist/index.cjs.js
// module id = 781
// module chunks = 0